import i18n from '../i18n.js';
export class OutputSettings {
  constructor(container, onChange) { this.container = container; this.onChange = onChange; this.format = 'png'; this.quality = 92; this.render(); this.bindEvents(); }
  render() {
    this.container.innerHTML =
      '<div class="form-group"><label class="form-label">' + i18n.t('config.output') + '</label>' +
      '<div class="format-tabs"><button class="format-tab active" data-format="png">PNG</button><button class="format-tab" data-format="jpeg">JPEG</button><button class="format-tab" data-format="webp">WebP</button></div>' +
      '<div class="quality-slider-group" id="quality-group" style="display:none;">' +
      '<span class="form-label" style="margin-bottom:0;">' + i18n.t('config.quality') + '</span>' +
      '<input type="range" class="quality-slider" id="quality-slider" min="10" max="100" value="92">' +
      '<span class="quality-value" id="quality-value">92%</span></div></div>';
    this.tabs = this.container.querySelectorAll('.format-tab');
    this.qualityGroup = this.container.querySelector('#quality-group');
    this.qualitySlider = this.container.querySelector('#quality-slider');
    this.qualityValue = this.container.querySelector('#quality-value');
  }
  bindEvents() {
    var self = this;
    this.tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        self.tabs.forEach(function(t) { t.classList.remove('active'); });
        tab.classList.add('active');
        self.format = tab.dataset.format;
        self.qualityGroup.style.display = (self.format === 'png') ? 'none' : 'flex';
        self.emitChange();
      });
    });
    this.qualitySlider.addEventListener('input', function() {
      self.quality = parseInt(self.qualitySlider.value, 10);
      self.qualityValue.textContent = self.quality + '%';
      self.emitChange();
    });
  }
  getSettings() {
    return { format: this.format, quality: this.format === 'png' ? 1.0 : this.quality / 100, mimeType: 'image/' + (this.format === 'jpeg' ? 'jpeg' : this.format), extension: this.format === 'jpeg' ? 'jpg' : this.format };
  }
  emitChange() { if (this.onChange) this.onChange(this.getSettings()); }
  updateI18n() {
    var l = this.container.querySelector('.form-label'); if (l) l.textContent = i18n.t('config.output');
    var ql = this.qualityGroup.querySelector('.form-label'); if (ql) ql.textContent = i18n.t('config.quality');
  }
}
